import ParsleyHelpers from '../util/ParsleyHelper';
import {
    LOADING_CLASS
} from '../constants/classes';
/**
 * Class Parsley helper
 * 
 * Initiate Parsley and add custom validator for passwords
 */

export default class FormValidationView {

    constructor(selector) {
        window.onload = () => {
            this.init(selector)
                .attachAria();
        }
    }

    /**
     * Method initialize parsley for a form instance
     *
     * @method init
     * @chainable
     * @public
     */
    init(selector) {
        this.$form = selector;
        this.$form.parsley();

        this.isRecaptchaValid = false;

        // finds cancel button that needs to be disabled once submit begins
        this.$disableOnSubmitEls = this.$form.find('[data-disable-on-submit]');

        // checks for recaptcha element
        this.$grecaptcha = this.$form.find('.js-recaptcha');

        if (this.$grecaptcha.length) {
            //need to wait for async script to load
            grecaptcha.render(this.$grecaptcha[0], {
                sitekey: recaptchaKey,
                size: 'invisible',
                callback: () => {
                    this.isRecaptchaValid = true;
                    this.$form.submit();
                },
                'error-callback': () => {
                    alert("A network error occured with recaptcha.  Please try again.");
                    this.removeLoadingClasses();
                }
            });
        }


        this.setupHandlers()
            .enable();

        return this;
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @chainable
     * @public
     */
    setupHandlers() {
        this.onSubmitHandler = this.onSubmit.bind(this);
        return this;
    }

    /**
     * Attaches
     *
     * @method enable
     * @chainable
     * @public
     */
    enable() {
        // onSubmit is called after validation succeeds and before the form is submitted
        this.$form.parsley().on('form:submit', this.onSubmitHandler);

        // //In the case of an error, remove the loading classes
        // this.$form.parsley().on('form:error', this.removeLoadingClasses);

        return this;
    }

    /**
     * Does any action on form submission event.
     *
     * @method enable
     * @chainable
     * @public
     */
    onSubmit(e) {

        this.addLoadingClasses();

        if (this.$grecaptcha.length) {

            if (this.isRecaptchaValid) {
                //if recaptcha was valid and we're submitting manually...
                console.log('submitting form')
                return true;
            }

            // else check recaptcha and suspend form
            console.log('executing grecaptcha')
            grecaptcha.execute();

            // return false to interrupt form submission
            return false;
        }
        return this;
    }

    /**
     * Method addLoadingClasses
     *
     * @method addLoadingClasses
     * @chainable
     * @public
     */
    addLoadingClasses() {
        this.$disableOnSubmitEls.length ? this.$disableOnSubmitEls.attr('disabled', true) : null;
        this.$form.find('.btn[type=submit]').addClass(LOADING_CLASS);
    }


    /**
     * Method removeLoadingClasses
     *
     * @method removeLoadingClasses
     * @chainable
     * @public
     */
    removeLoadingClasses() {
        this.$disableOnSubmitEls.length ? this.$disableOnSubmitEls.attr('disabled', false) : null;
        this.$form.find('.btn[type=submit]').removeClass(LOADING_CLASS);
    }

    /**
     * Method attach events that control aria attributes
     *
     * @method attachAria
     * @chainable
     * @public
     */
    attachAria() {
        window.Parsley.on('field:error', function () {
            this.$element.attr('aria-describedby', this._ui.errorsWrapperId).attr('aria-invalid', 'true');
            this._ui.$errorsWrapper.attr('aria-live', 'assertive');

        });

        window.Parsley.on('field:success', function () {
            if (this.$element.attr('aria-invalid')) {
                this.$element.removeAttr('aria-invalid');
            }
        });
    }

}